import { updatePaymentMethod, updatePayoutMethod } from "../../services/api";
import {
  formatMethodsForPaymentIntent,
  formatMethodsForPayoutIntent,
  formatPaymentResponse,
  formatPayoutResponse,
} from "./utils";

export const sdkResetSelectedMethod = async ({
  intentType,
  intentId,
  lang,
}: {
  intentType: "payment" | "payout";
  intentId: string;
  lang: string;
}) => {
  if (intentType === "payment") {
    const response = await updatePaymentMethod(intentId, lang);
    return {
      ...formatPaymentResponse(response),
      methods: formatMethodsForPaymentIntent(response),
    };
  }

  const response = await updatePayoutMethod(intentId, lang);
  return {
    ...formatPayoutResponse(response),
    method: formatMethodsForPayoutIntent(response),
  };
};
